module.exports = __webpack_public_path__ + "static/media/elc_social_logo.fc48ec59.png";